/**
 * Pro = lifetime Pro, or monthly Pro whose expiry is in the future.
 * Pro members keep every opt-in rewarded ad but are spared forced placements
 * (post-claim / post-game / post-spin / Home timer).
 */
export default function isProUser(user: any): boolean {
  if (!user) return false;
  if (user.isLifetimePro) return true;
  const seconds = user.proExpiry?.seconds ?? (user.proExpiry?.toDate ? user.proExpiry.toDate().getTime() / 1000 : undefined);
  return !!user.isPro && !!seconds && seconds * 1000 > Date.now();
}
